import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

function ViewNotSupportedCard() {
  return (
    <Card>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          View not supported
        </Typography>
        <Typography variant="body2" component="p">
          At the moment, we only support Rescuer activities on mobile devices.
          Please increase your window width or use a larger device.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ViewNotSupportedCard;
